<template>
    <div>
        <div class="smallContent miscContent">
            <p>
                Montez Press Radio is an experimental broadcasting and
                performance platform. We were founded in 2018 with the goal of
                fostering greater experimentation and conversation between
                artists, writers, and thinkers through the medium of radio. This
                platform invites different corners of the art world to interact
                with each other in person and on air—a place where media finally
                meets flesh. We’re drawn to art that exists in the unexpected,
                the authenticity of sharing without a script, the sounds of
                ideas in the making, conversation that forgets there’s an
                audience. We also like books. All of our in-studio broadcasts
                are free and open to the public. Stop by when we’re live at 46
                Canal Street (2nd Floor) in NYC or look at the upcoming schedule
                to see if we’re off-site and broadcasting near you. Queries and
                programming proposals can be submitted via
                <router-link :to="{ name: 'proposal' }">this form</router-link>.
            </p>
            <br />

            <p>
                Montez Press Radio is dependent on the
                <a
                    href="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=SSUW4WD7HN8YU&source=url"
                    target="_blank"
                    >donations</a
                >
                of listeners like you (Your donations are tax-deductible to the
                fullest extent of the law).
            </p>
            <br />
            <p>
                Our archive is an ongoing auditory document of Montez Press
                Radio’s existence. It is not designed to reflect the ingenuity
                of post-production, but rather serves as a catalogue of rough
                cuts which contain all the small glitches, false starts, and
                awkward silences that are intrinsic to our process of live
                recording and running an event space. Montez Press Radio is as
                much a radio broadcast as it is a reflection of particular
                moments in time. When we’re not live, users can listen to our
                fully unedited files by adding past shows to our public playlist
                (which functions like a jukebox) or, better yet, can gain
                instant access by subscribing
                <router-link :to="{ name: 'subscribe' }"
                    >subscribing</router-link
                >
                to MPR.
            </p>
            <br />

            <p>
                Staff:<br />
                <a href="mailto:stacy@montezpress.com">Stacy Skolnik</a>
                (Executive Director)<br />
                <a href="mailto:thomas@montezpress.com">Thomas Laprade</a>
                (Curatorial Director)<br />
                <a href="mailto:maxwell@montezpress.com">Maxwell Ludlow</a>
                (Curatorial Associate and Communications Manager)<br />
            </p>
            <br />
            <p>
                Programming: <br />
                Emily Pope (London)<br />
                Manda Shutler (London)<br />
                Fabiola Talavera (Mexico)<br />
                Leah Whitman-Salkin (Mexico)<br />
            </p>
            <br />
            <p>
                Website: <br />
                <a href="https://jmmp.studio" target="_blank"
                    >JMMP – Julian Mader, Max Prediger</a
                >
                (Design) <br />
                <a href="https://dominicosterried.de" target="_blank"
                    >Dominic Osterried</a
                >
                (Development) <br />
            </p>
            <br />
            <p>
                Board of Directors: <br />
                Anna Clark (President) <br />
                Jacques Louis-Vidal (Treasurer) <br />
                Jeremy Toussaint-Baptiste (Secretary) <br />
                Martha Fuller Clark <br />
                Than Clark <br />
                Rafael Foster <br />
                C. Spencer Yeh <br />
                Galen Joseph-Hunter<br />
            </p>
            <br />
            <p>
                Account Support: <br />
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                ><br />
            </p>
            <br />
            <p>
                Funders: <br />
                Montez Press Radio is funded in part by a grant from the New
                Hampshire Charitable Foundation’s Geoffrey E. Clark and Martha
                Fuller Clark Fund. <br />
                Montez Press Radio’s programs are made possible by the New York
                State Council on the Arts with the support of the Office of the
                Governor and the New York State Legislature. <br />
                Major support for Montez Press Radio is provided by The Andy
                Warhol Foundation for the Visual Arts.<br />
                This program is supported, in part, by public funds from the New
                York City Department of Cultural Affairs in Partnership with the
                City Council. <br />
                We are supported by a grant from IndieSpace through The Little
                Venue That Could Grant Program.<br />
                Montez Press Radio was supported by New Music USA's Organization
                Fund in 2026-27. <br />
                We are supported by a grant from IndieSpace through The Little
                Venue That Could Grant Program.<br />
            </p>

            <br />
            <br />
            <!--
            <p>
                <a href="https://wavefarm.org/" target="_blank"
                    >Wave Farm, Inc.</a
                >
                (EIN 83-0346659) serves as a Program Sponsor to Montez Press
                Radio.
            </p>
            <p>
                Your
                <a
                    href="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=SSUW4WD7HN8YU&source=url"
                    target="_blank"
                    >donations</a
                >
                are tax-deductible to the fullest extent of the law.
            </p>
            <br />

            <p>
                Our archive is an ongoing auditory document of Montez Press
                Radio’s existence. It is not designed to reflect the ingenuity
                of post-production, but rather serves as a catalogue of rough
                cuts which contain all the small glitches, false starts, and
                awkward silences that are intrinsic to our process of live
                recording and running an event space. Montez Press Radio is as
                much a radio broadcast as it is a reflection of particular
                moments in time. When we're not live, users can listen to our
                fully unedited files by adding past shows to our public playlist
                (which functions like a jukebox) or, better yet, can gain
                instant access by subscribing to MPR.
            </p>
            <br />

            <p class="form">Montez Press Radio is dependent on the&nbsp;</p>
            <form
                id="donate"
                target="_blank"
                action="https://www.paypal.com/cgi-bin/webscr"
                method="post"
            >
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input
                    type="hidden"
                    name="hosted_button_id"
                    value="SSUW4WD7HN8YU"
                />
                <input id="donateSubmit" type="submit" value="donations" />
            </form>
            <p class="form">
                and support of listeners like you. Please consider joining our
                community of supporters by subscribing
            </p>
            <br />
            <router-link class="buttonLink" :to="{ name: 'subscribe' }"
                >Support Montez Press Radio</router-link
            >
            <br />
            <p class="form">
                Queries and programming proposals can be submitted via this
                form:
            </p>
            <br />
            <router-link class="buttonLink" :to="{ name: 'proposal' }"
                >Submit Programming Proposal</router-link
            >

            <br />

            -->
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from "./Footer.vue";
export default {
    name: "About",
    components: {
        Footer,
    },
};
</script>

<style scoped>
/* div { */
/*     width: calc(100% - 2rem); */
/* } */
/* @media only screen and (min-width: 1101px){ */
/* div { */
/*     width: calc(66% - 2rem); */
/* } */
/* } */
/* @media only screen and (min-width: 1440px){ */
/* div { */
/*     width: calc(50% - 2rem); */
/* } */
/* } */
/* @media only screen and (min-width: 1900px){ */
/* div { */
/*     width: calc(33% - 2rem); */
/* } */
/* } */

p {
    margin: 0;
}

a {
    color: #aaaaaa;
    cursor: pointer;
}

a:hover {
    color: black;
}

input[type="submit"] {
    width: auto;
    border: none;
    color: #aaaaaa;
    padding: 0;
    display: inline;
    margin: 0;
}

input[type="submit"]:hover {
    color: black;
    background-color: transparent;
}

form {
    display: inline;
}

p.form {
    display: inline;
}

a.buttonLink {
    border: 1px solid black;
    padding: 0.65rem 1rem 0.85rem;
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    margin-bottom: 2rem;
    margin-top: 2rem;
    color: black;
}

a.buttonLink:hover {
    background-color: black;
    color: white;
}
</style>
